const ProjectServices = ({ services }: { services: string[] | null }) => {
  const MAX_NO_services = 3;
  return (
    <span className="text-base text-blank-yellow-tint-70 mt-16">
      {services ? services.slice(0, MAX_NO_services).join(' · ') : ''}
      {services && services.length > MAX_NO_services && (
        <span>
          {' · '}+{services.length - MAX_NO_services}
        </span>
      )}
    </span>
  );
};

export default ProjectServices;
